import RouterCard from './RouterCard';

export default RouterCard;
